import axios from '@/libs/api.request'

/**
 * 获取大屏显示数据
 */
export const indexData = () => {
    return axios.request({
        url: '/api/admin/moniter/index',
        method: 'post'
    })
}

/**
 * 获取大屏显示数据 -- 实时数据
 */
export const realData = () => {
    return axios.request({
        url: '/api/admin/moniter/data',
        method: 'get'
    })
}

/**
 * 获取设备列表
 */
export const deviceList = () => {
    return axios.request({
        url: '/api/admin/moniter/deviceList',
        method: 'get'
    })
}

/**
 * 正在进行的抽检报告列表
 */
export const workingList = () => {
    return axios.request({
        url: '/api/admin/moniter/workingList',
        method: 'get'
    })
}

/**
 * 正在进行的抽检报告详情
 */
export const workingInfo = (id) => {
    let data = {
        "id": id
    }
    return axios.request({
        url: '/api/admin/moniter/workingInfo',
        data,
        method: 'post'
    })
}

/**
 * 获取设备实时数据
 */
export const getRealTimeDataByDeviceCode = (device_code) => {
    let data = {
        "device_code": device_code
    }
    return axios.request({
        url: '/api/admin/moniter/getRealTimeDataByDeviceCode',
        data,
        method: 'post'
    })
}